export const addServerPath = (path) => {
  if (process.env.serverPath) {
    if (path.startsWith('http')) return path
    return `${process.env.serverPath}${path}`
  }
  console.error('process.env.serverPath not found')
  return path
}

export default (context, inject) => {
  inject('addServerPath', addServerPath)
  context.$addServerPath = addServerPath
}
